<!-- <app-d-form-group *ngIf="visible" (formLoaded)="emitControl()" (control)="linkTrainerFormControl = $event" [formArray]="linkTrainerForm" type="modalForm" (submit)="onSubmit($event)"></app-d-form-group> -->

<div [formGroup]="linkTrainerForm">
    <div class="form-group m-form__group row">
        <div class="col-1"></div>
        <label for="example-search-input" class="col-3 col-form-label">
            Enter Trainer SIP ID:
            <span class="red">*</span>
        </label>
        <div class="col-7">
            <input [readOnly]="isModalOpen" class="form-control m-input nameBackground" type="text" formControlName="trainerId" (blur)="getTrainerName()" placeholder="Enter Trainer SIP ID">
            <app-form-control-messages [control]="linkTrainerForm.get('trainerId')" [name]="'Trainer SIP ID'">
            </app-form-control-messages>
        </div>
    </div>
    <div class="form-group m-form__group row">
        <div class="col-1"></div>
        <label for="example-search-input" class="col-3 col-form-label">
            Name of the Trainer:
            <span class="red">*</span>
        </label>
        <div class="col-7">
            <input class="form-control m-input nameBackground" disabled type="text" formControlName="trainerName" placeholder="Enter Trainer Name">
            <app-form-control-messages [control]="linkTrainerForm.get('trainerName')" [name]="'Trainer Name'">
            </app-form-control-messages>
        </div>
    </div>
    <div class="form-group m-form__group row">
        <div class="col-1"></div>
        <label for="example-search-input" class="col-3 col-form-label">
            Associated Training Centre:
            <span class="red">*</span>
        </label>
        <div class="col-7">
            <input class="form-control m-input nameBackground" [readonly]="isDisabled" formControlName="associatedTrainingCentre" type="text" placeholder="Search by Training Centre ID or Name" (keyup)="getTrainingCentreList($event)" list="trainingCentres" required>
            <datalist id="trainingCentres">
                <option *ngFor="let tc of trainingCentreList" [ngValue]=tc.userName>
                    {{tc.trainingCentreName}} ({{tc.userName}})</option>
            </datalist>
            <app-form-control-messages [control]="linkTrainerForm.get('associatedTrainingCentre')" [name]="'Associated TrainingCentre'">
            </app-form-control-messages>
        </div>
    </div>
    <div formGroupName="validity">
        <div class="form-group m-form__group row">
            <div class="col-1"></div>
            <label for="example-search-input" class="col-3 col-form-label">
                Validity:
                <span class="red">*</span>
            </label>
            <div class="input-group col-4">
                <input class="form-control" placeholder="From Date" name="fromDate" formControlName="fromDate" (click)="fromDate.toggle();$event.stopPropagation();" (document:click)="closeFix($event, fromDate)" ngbDatepicker readonly (dateSelect)="selectedStartDate($event)"
                    #fromDate="ngbDatepicker">
                <div class="input-group-append">
                    <span class="input-group-text" (click)="fromDate.toggle();$event.stopPropagation();">
                        <i class="la la-calendar-check-o"></i>
                    </span>
                </div>
                <app-form-control-messages [control]="linkTrainerForm.get('validity').get('fromDate')" [name]="'From Date'"></app-form-control-messages>
                <!-- <app-date-picker [model]="startDateObject" (dateChanged)="selectedStartDate($event)">
                </app-date-picker> -->
            </div>
            <div class="input-group col-3">
                <input class="form-control" placeholder="to Date" name="toDate" formControlName="toDate" (document:click)="closeFix($event, toDate)" (click)="toDate.toggle();$event.stopPropagation();" readonly ngbDatepicker (dateSelect)="selectedEndDate($event)" #toDate="ngbDatepicker">
                <div class="input-group-append">
                    <span class="input-group-text" (click)="toDate.toggle();$event.stopPropagation();">
                        <i class="la la-calendar-check-o"></i>
                    </span>
                </div>
                <app-form-control-messages [control]="linkTrainerForm.get('validity').get('toDate')" [name]="'To Date'"></app-form-control-messages>
                <!-- <app-date-picker [model]="endDateObject" (dateChanged)="selectedEndDate($event)">
                </app-date-picker> -->
            </div>
        </div>
    </div>
    <div class="form-group m-form__group row">
        <div class="col-1"></div>
        <label for="example-search-input" class="col-3 col-form-label">
            Supporting Document:
            <span class="red">*</span>
        </label>
        <div class="col-sm-8">
            <app-upload-file [formValue]="linkTrainerForm.get('supportingDocument')" [(localFile)]="localFileName.supportingDocument" fileType="supportingDocument" info="only jpg, png, jpeg, pdf"></app-upload-file>
            <input type="hidden" formControlName="supportingDocument" #fileInput>
            <app-form-control-messages [control]="linkTrainerForm.controls.supportingDocument" [name]="'Upload Related Document'"></app-form-control-messages>
        </div>
    </div>
</div>

<hr>
<div class="row" style="padding-bottom:30px">
    <div style="margin-left:40%">
        <button class="btn btn-info" (click)="takeAction()">{{ submitText }}</button>
        <button class="btn btn-secondary" data-dismiss="modal" aria-label="Close" (click)="closeModel()">Cancel</button>
    </div>
</div>